import { connect } from 'react-redux';
import { bindActionCreators, type Dispatch } from 'redux';
import { blurField, changeDiscriminatorField, focusField, setUI } from '../../actions';
import { makeValueSelector } from '../../selectors';
import type { SchemaFieldProps, SchemaFormSlice } from '../../types';
import ScalarField from '../scalar-field/scalar-field';

const getMapStateToProps = () => {
  const selector = makeValueSelector();
  return (state: SchemaFormSlice, props: SchemaFieldProps) => selector(state, props);
};

const mapDispatchToProps = (dispatch: Dispatch, { formName, path, schemaPath }: SchemaFieldProps) =>
  bindActionCreators(
    {
      onChange: changeDiscriminatorField(formName, path, schemaPath),
      onChangeSilent: changeDiscriminatorField(formName, path, schemaPath),
      onBlur: blurField.bind(null, formName, path),
      onFocus: focusField.bind(null, formName, path),
      setUI: setUI.bind(null, formName, path)
    },
    dispatch
  );

export default connect(getMapStateToProps, mapDispatchToProps)(ScalarField);
